import { Rotas } from "constants/EnumRotas";
import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { queryClient } from "shared/util/queryClient";

export const usePostCadastrarClienteGroupPay = (codigoSuporte: string) => {
  const navigate = useNavigate();

  const onError = () => {
    toast.error("Erro ao dar início no cadastro do Group Pay");
  };

  const onSuccess = () => {
    queryClient.invalidateQueries(["status-ativacao-group-pay"]);
    toast.success("Em breve nosso time comercial entrará em contato");
    navigate(Rotas.GROUP_PAY);
  };

  return usePost({
    url: api.groupPay.postIniciarCadastroGroupPay,
    onError,
    onSuccess,
    pathVariables: codigoSuporte,
  });
};
